import { ReplayIcon } from '@/components/ui/Icons';
import './AgentSendRetryBar.css';

export interface AgentMessageRetryButtonProps {
  onRetry: () => void;
  disabled?: boolean;
}

/** Кнопка повторной отправки рядом с пользовательским баблом (ошибка доставки). */
export function AgentMessageRetryButton({ onRetry, disabled }: AgentMessageRetryButtonProps) {
  return (
    <div className="agentMessageRetry">
      <button
        type="button"
        className="agentMessageRetry__btn"
        aria-label="Повторить отправку"
        title="Повторить отправку"
        onClick={onRetry}
        disabled={disabled}
      >
        <ReplayIcon size={13} />
      </button>
    </div>
  );
}
